import React from "react";
import LegalShell, { Section } from "@/pages/legal/LegalShell";

const UPDATED = "16 January 2026";

export default function Terms() {
  return (
    <LegalShell eyebrow="§ Legal · 01" title={<>Terms &amp; <span className="saffron">Conditions.</span></>} updated={UPDATED}>
      <p>
        These Terms &amp; Conditions (&quot;Terms&quot;) govern your access to and use of the Forte² Space
        platform (the &quot;Platform&quot;), operated by <strong className="text-white">Gritly Analytics Private
        Limited</strong>, a company incorporated under the Companies Act, 2013, having its office in
        Chennai, Tamil Nadu, India (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;). By accessing or using the Platform, you
        agree to be bound by these Terms.
      </p>

      <Section n="1" title="Eligibility">
        <p>You must be at least 18 years of age to create an account. If you are between 13 and 18, you may
        access the Platform only with verifiable parental or guardian consent, as required under the Digital
        Personal Data Protection Act, 2023 (&quot;DPDP Act&quot;). The Platform is not intended for children below 13.</p>
      </Section>

      <Section n="2" title="The Service">
        <p>Forte² Space provides career readiness diagnostics, learning pathways, mentorship connections and a
        talent marketplace focused on the Indian space economy. Content and recommendations are provided for
        informational purposes and do not constitute legal, financial, insurance or investment advice.</p>
      </Section>

      <Section n="3" title="Accounts &amp; Security">
        <p>You are responsible for maintaining the confidentiality of your credentials (including your Google
        sign-in). You agree to notify us at <span className="saffron">[email protected]</span> of any
        unauthorised use of your account.</p>
      </Section>

      <Section n="4" title="Acceptable Use">
        <p>You will not (a) upload unlawful, defamatory, obscene or infringing content; (b) attempt to reverse
        engineer, scrape or disrupt the Platform; (c) use the Platform to breach any applicable law of India,
        including the Information Technology Act, 2000, the IT (Intermediary Guidelines and Digital Media
        Ethics Code) Rules, 2021, or the DPDP Act, 2023.</p>
      </Section>

      <Section n="5" title="Payments &amp; Pricing">
        <p>Paid features on the Platform are billed in Indian Rupees (INR) inclusive of applicable GST.
        Payments are processed through Indian payment gateways. <strong className="text-white">We do not
        currently accept cross-border payments.</strong> If your payment card or account is issued outside
        India, checkout may be declined.</p>
      </Section>

      <Section n="6" title="Refunds">
        <p>All purchases of digital services on the Platform are <strong className="text-white">final and
        non-refundable</strong>, save where required by applicable Indian law. Please review our{" "}
        <a href="/refund" className="saffron underline">Refund Policy</a> for full details.</p>
      </Section>

      <Section n="7" title="Intellectual Property">
        <p>All content, code, scoring models (including the Forte² Score), designs, trademarks and logos
        displayed on the Platform are the exclusive property of Gritly Analytics Private Limited or its
        licensors. You may not reproduce, modify or distribute them without our prior written consent.</p>
      </Section>

      <Section n="8" title="User-Generated Content">
        <p>By submitting content (assessment answers, profile data, contact messages) you grant us a
        non-exclusive, royalty-free, worldwide licence to use such content solely to operate and improve the
        Platform, subject to our Privacy Policy.</p>
      </Section>

      <Section n="9" title="AI-Generated Reports">
        <p>Reports produced by the Platform use large-language models and are
        provided on an &quot;as is&quot; basis. Reports are indicative and must not be relied upon as the sole basis
        for career, hiring, investment or insurance decisions.</p>
      </Section>

      <Section n="10" title="Third-Party Services">
        <p>The Platform integrates with third parties including Google (authentication), Emergent (LLM
        infrastructure) and Resend (transactional email). Your use of such third-party services is subject to
        their respective terms.</p>
      </Section>

      <Section n="11" title="Limitation of Liability">
        <p>To the maximum extent permitted under Indian law, the Company&apos;s aggregate liability arising out of
        or in connection with your use of the Platform shall not exceed the fees paid by you to the Company
        in the twelve (12) months preceding the event giving rise to the claim.</p>
      </Section>

      <Section n="12" title="Indemnity">
        <p>You agree to indemnify and hold harmless the Company and its officers, directors and employees
        from any claims arising out of your breach of these Terms or violation of applicable law.</p>
      </Section>

      <Section n="13" title="Suspension &amp; Termination">
        <p>We may suspend or terminate your account without notice if we reasonably believe you have violated
        these Terms or applicable law. You may terminate your account at any time by writing to{" "}
        <span className="saffron">[email protected]</span>.</p>
      </Section>

      <Section n="14" title="Grievance Officer">
        <p>Pursuant to the IT (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, the
        Grievance Officer may be reached at <span className="saffron">[email protected]</span> with the
        subject &quot;Grievance&quot;. We will acknowledge complaints within 24 hours and resolve them within 15 days.</p>
      </Section>

      <Section n="15" title="Governing Law &amp; Jurisdiction">
        <p>These Terms shall be governed by and construed in accordance with the laws of India. Courts at
        <strong className="text-white"> Chennai, Tamil Nadu </strong> shall have exclusive jurisdiction over
        any disputes arising out of or in connection with the Platform.</p>
      </Section>

      <Section n="16" title="Changes">
        <p>We may update these Terms from time to time. Continued use of the Platform after changes
        constitutes acceptance of the revised Terms.</p>
      </Section>
    </LegalShell>
  );
}
